import type { Release } from '../releases.ts';

export default {
  version: '0.2.0',
  date: '2026-09-28',
  title: 'Metadata and hybrid storage',
  summary: [
    'Metadata models you can configure',
    'Storage policies, verified transfers and the first storage agent',
    'Fixed: variable frame rate sources are normalised to their nominal rate',
  ],
  features: [
    'Configurable metadata models',
    'Storage policies, verified transfers and the first storage agent',
  ],
  fixes: ['Variable frame rate sources are normalised to their nominal rate'],
} satisfies Release;
